import * as React from 'react';

interface TabsContextValue {
  activeTabId: string;
  setActiveTabId: React.Dispatch<string>;
}

const TabsContext = React.createContext<TabsContextValue>({} as TabsContextValue);

export const Tabs: React.FC<{ activeTabId: string }> = ({ children, activeTabId }) => {
  const [_activeTabId, setActiveTabId] = React.useState(activeTabId);
  return <TabsContext.Provider value={{ activeTabId: _activeTabId, setActiveTabId }}>{children}</TabsContext.Provider>;
};

export const useTab = (tabId: string) => {
  const { activeTabId, setActiveTabId } = React.useContext(TabsContext);
  return {
    onClick: () => setActiveTabId(tabId),
    isActive: activeTabId === tabId,
  };
};

export interface TabProps {
  isActive?: boolean;
}

export const TabPanel: React.FC<{ tabId: string }> = ({ children, tabId }) => {
  const { activeTabId } = React.useContext(TabsContext);

  return <>{activeTabId === tabId ? children : null}</>;
};
